const React = require('react');
const createReactClass = require('create-react-class');
const FuzzyReaction = require('../../../bootstrap').FuzzyReaction;
const Form = FuzzyReaction.Components.ResourceBinding.Form.Form;
const ResourceActions = FuzzyReaction.Actions.ResourceActions;
const FormStore = FuzzyReaction.Stores.FormStore;
const Button = FuzzyReaction.Components.Global.Button;
const Modal = FuzzyReaction.Components.Global.Modal;
const Column = Form.Column;
const Row = Form.Row;
const TracksStore = require('../../../stores/TracksStore');
const AlbumsStore = require('../../../stores/AlbumsStore');
const ArtistsStore = require('../../../stores/ArtistsStore');
const ProgressModal = require('../../components/UploadProgress');
const UploadProgressMixin = require('../../components/UploadProgressBarMixin');

const AddManualTrack = createReactClass({
    displayName: 'AddManualTrack',

    mixins: [UploadProgressMixin],

    getInitialState: function () {
        return {
            query: {},
            albums: [],
            track: {},
            progress: {},
            newTrackData: {
                is_dmca_restricted: 1
            },
            openUploadProgressModal: false,
            openDuplicateTrackModal: false,
            searchingForAlbum: false,

            mQuery: {},
            newManualTrackData: {},
            openAddManuallyModal: false,
            workingResource: {}
        }
    },

    artistsResourceAction: new ResourceActions('artists'),
    albumsResourceAction: new ResourceActions('albums'),

    /**
     * Resource action handler's options
     */
    getOptions: {
        dataNode: 'data'
    },

    sendOptions: {
        modifiers: {
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data'
    },

    divStyle: {
        height: 300,
        overflowY: 'visible',
        overflowX: 'hidden',
    },

    /**
     * Edit user form key
     */
    addTrack: 'addTrack',

    _validateTrack: function () {

        if (typeof this.state.newTrackData !== 'undefined') {
            if (typeof this.state.newTrackData.albums === 'undefined') {
                if (this._setNonExistingAlbum('placeholder', 'Album Name') === '') {
                    return false;
                }
            }

            if (typeof this.state.newTrackData.artists === 'undefined') {
                if (this._setNonExistingArtist('placeholder', 'Artist Name') === '') {
                    return false;
                }
            }

            if (typeof this.state.newTrackData.marketing_label === 'undefined' ||
                typeof this.state.newTrackData.title === 'undefined' ||
                typeof this.state.newTrackData.isrc === 'undefined') {
                return false;
            }

            return this.state.newTrackData.audio instanceof File;
        }

        return false;
    },

    /**
     * Register event listeners and fire request for data
     */
    componentDidMount: function () {
        TracksStore.addChangeListener(this._onChange);
        AlbumsStore.addChangeListener(this._onChange);
        ArtistsStore.addChangeListener(this._onChange);
        FormStore.addChangeListener(this._onChange);
    },

    /**
     * Deregister an event listener
     */
    componentWillUnmount: function () {
        AlbumsStore.addChangeListener(this._onChange);
        ArtistsStore.addChangeListener(this._onChange);
        FormStore.removeChangeListener(this._onChange);
    },

    _setNonExistingArtist: function (attribute, val) {
        const ctrl = "[" + String(attribute) + "='" + String(val) + "']";

        if ($(ctrl)) {
            return $(ctrl).val() || ''
        } else return {}
    },

    _setNonExistingAlbum: function (attribute, val) {
        const ctrl = "[" + String(attribute) + "='" + String(val) + "']";

        if ($(ctrl)) {
            return $(ctrl).val() || ''
        } else return {}
    },

    /**
     * Listen to changes in TracksStore and get new data
     * @private
     */
    _onChange: function () {
        this.setState({
            progress: TracksStore.getUploadProgress()
        });
    },

    _setManualObjectToSend: function (manualTrackData) {
        let album, artist;

        if (manualTrackData.albums) {
            if (manualTrackData.albums.length > 0) {
                album = manualTrackData.albums[0].album;
            }
        }

        if (typeof album === 'undefined') {
            album = this._setNonExistingAlbum('placeholder', 'Album Name');
        }

        if (manualTrackData.artists) {
            if (manualTrackData.artists.length > 0) {
                artist = manualTrackData.artists[0].artist;
            }
        }

        if (typeof artist === 'undefined') {
            artist = this._setNonExistingArtist('placeholder', 'Artist Name');
        }

        return {
            album: album,
            artist: artist,
            audio: manualTrackData.audio,
            isrc: manualTrackData.isrc,
            title: manualTrackData.title,
            marketing_label: manualTrackData.marketing_label,
            is_dmca_restricted: manualTrackData.is_dmca_restricted ? 1 : 0
        };
    },

    /**
     * Action handlers
     *
     * @param action
     * @param resource
     */
    handleAction: function (action, resource) {
        switch (action) {
            case 'save':
                if (this._validateTrack()) {
                    this.setState({
                        progress: {
                            loaded: 0,
                            total: 100
                        },
                        openUploadProgressModal: true
                    }, function () {
                        const tracks = new ResourceActions('tracks');
                        this.sendOptions.contentType = 'form';
                        this.sendOptions.deepObjectParse = true;

                        // Track already exists
                        if (typeof this.state.newTrackData.id !== 'undefined') {
                            this.setState({
                                openDuplicateTrackModal: true,
                                openUploadProgressModal: false
                            });
                        } else {
                            tracks.createResource(this._setManualObjectToSend(this.state.newTrackData), this.sendOptions);
                            this._onChange();
                        }
                    });
                }
                break;
            case 'goBack':
                this.props.history.push('/music-library');
                break;
        }
    },

    /**
     * Handle modal close
     */
    closeModal: function () {
        this.setState({
            openUploadProgressModal: false,
            openDuplicateTrackModal: false
        });
    },

    /**
     * Direct the user back to the music library
     */
    transitionToLibrary: function () {
        this.props.history.push('/music-library');
    },

    render: function () {
        const disableSave = this._validateTrack() ? null : 'disabled';

        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"/>
                    <Row classes="align-items-center">
                        <Column grid="lg" size="6">
                            <h1 className="page-header">Music Library: Add Manual Track</h1>
                        </Column>
                    </Row>
                    <Column grid="lg" size="12">
                        <div className="card card-default">
                            <div className="card-body">
                                <Row>
                                    <Column grid="lg" size="5">
                                        <Form key={this.addTrack} formKey={this.addTrack}
                                              bindResource={this.state.newTrackData}>

                                            <Row>
                                                <Form.AutoSuggestInput fieldKey="artists" source="remote"
                                                                       resourceAction={this.artistsResourceAction}
                                                                       required={true}
                                                                       label="Artist" placeholder="Artist Name"
                                                                       limit={1} textLimit={191} fields={['artist']}
                                                                       options={{}}
                                                                       helpText=""/>
                                            </Row>

                                            <Row>
                                                <Form.AutoSuggestInput fieldKey="albums" type="text" source="remote"
                                                                       resourceAction={this.albumsResourceAction}
                                                                       required={true}
                                                                       label="Album" placeholder="Album Name"
                                                                       limit={1} textLimit={255}
                                                                       validations="isLength:1:255" fields={['album']}
                                                                       options={{}}
                                                                       helpText=""/>
                                            </Row>

                                            <Row>
                                                <Form.Input fieldKey="title" type="text" label="Track Title"
                                                            placeholder="Track Title" limit={255}
                                                            validations="isLength:1:255"
                                                            required="true"/>
                                            </Row>
                                            <Row>
                                                <Form.Input fieldKey="isrc" type="text" label="Track ISRC"
                                                            placeholder="ISRC" limit={255} validations="isLength:1:255"
                                                            required="false"/>
                                            </Row>
                                            <Row>
                                                <Form.Input fieldKey="marketing_label" type="text"
                                                            label="Marketing Label"
                                                            placeholder="Marketing Label" limit={150}
                                                            validations="isLength:1:150"
                                                            required="false"/>
                                            </Row>
                                            <Row>
                                                <Form.Checkbox fieldKey="is_dmca_restricted"
                                                               label="DMCA Restriction"
                                                               options={[{
                                                                   name: 'isDmcaRestricted',
                                                                   value: 1,
                                                                   label: "DMCA Restricted"
                                                               }]}/>
                                            </Row>
                                            <Row>
                                                <Form.File fieldKey="audio" options={{
                                                    height: 120,
                                                    width: 250,
                                                    b64encoded: false,
                                                    hidePreview: true
                                                }}
                                                           accept="audio"
                                                           label="Add Music Track"
                                                           helpText="We recommend that you upload an mp3 file under 50MB. The file will transcode once it is uploaded."/>
                                            </Row>
                                        </Form>
                                    </Column>
                                </Row>

                                <Row classes="justify-content-end">
                                    <Button action="goBack" text="Go Back" handleAction={this.handleAction}/>
                                    <Button action="save" text="Add Track" handleAction={this.handleAction}
                                            mods={['primary', disableSave]}/>
                                </Row>
                            </div>
                        </div>
                    </Column>
                </div>

                <Modal openWhen={this.state.openUploadProgressModal}
                       title="Upload Progress" disableButtons={this.uploadProgress() !== '100%'}
                       afterClose={this.closeModal}
                       showButton="save"
                       saveText="Continue to Music Library"
                       beforeSave={this.transitionToLibrary}
                       afterSave={this.closeModal}>
                    <ProgressModal progressWidth={this.uploadProgress()}
                                   successText={'Successfully uploaded track and queued transcoding. Check back in 10-15 minutes.'}/>
                </Modal>

                <Modal openWhen={this.state.openDuplicateTrackModal}
                       title="Track Already Exists"
                       afterClose={this.closeModal}
                       showButton="save"
                       saveText="Upload another track"
                       afterSave={this.closeModal}>
                    <p>This track already exists!</p>
                </Modal>
            </div>
        )
    },
});

module.exports = AddManualTrack;
